var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-toolbar",
        { attrs: { dense: "", color: "primary", dark: "" } },
        [_c("v-toolbar-title", [_vm._v("Add Metadata Schema")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.step,
            callback: function ($$v) {
              _vm.step = $$v
            },
            expression: "step",
          },
        },
        [
          _c(
            "v-stepper-content",
            { attrs: { step: "1" } },
            [
              _c(
                "v-form",
                {
                  ref: "form_step1",
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.isValidForm,
                    callback: function ($$v) {
                      _vm.isValidForm = $$v
                    },
                    expression: "isValidForm",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              box: "",
                              label: "Schema Name",
                              rules: _vm.schemaNameRule,
                            },
                            model: {
                              value: _vm.schemaName,
                              callback: function ($$v) {
                                _vm.schemaName = $$v
                              },
                              expression: "schemaName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            disabled: !_vm.isValidForm,
                          },
                          on: {
                            click: function ($event) {
                              _vm.step = 2
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("chevron_right")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Next")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { depressed: "" },
                          on: { click: _vm.clickCancel },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-stepper-content",
            { attrs: { step: "2" } },
            [
              _c(
                "v-form",
                {
                  ref: "form_step2",
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.isValidForm,
                    callback: function ($$v) {
                      _vm.isValidForm = $$v
                    },
                    expression: "isValidForm",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm._l(_vm.metadataFields, function (field, i) {
                            return _c(
                              "v-flex",
                              { key: field.Key, attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs7: "",
                                          "pl-2": "",
                                          "pr-2": "",
                                        },
                                      },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            box: "",
                                            label: "Field Name",
                                            rules: _vm.fieldNameRule,
                                          },
                                          model: {
                                            value: field.Field,
                                            callback: function ($$v) {
                                              _vm.$set(field, "Field", $$v)
                                            },
                                            expression: "field.Field",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs4: "",
                                          "pl-2": "",
                                          "pr-2": "",
                                        },
                                      },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            box: "",
                                            label: "Field Type",
                                            items: _vm.fieldTypeNames,
                                            rules: _vm.fieldTypeRule,
                                          },
                                          model: {
                                            value: field.FieldType,
                                            callback: function ($$v) {
                                              _vm.$set(field, "FieldType", $$v)
                                            },
                                            expression: "field.FieldType",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs1: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              fab: "",
                                              icon: "",
                                              small: "",
                                              outline: "",
                                              color: "error",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeField(i)
                                              },
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("close")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    outline: "",
                                    color: "success",
                                    disabled: !_vm.isValidForm,
                                  },
                                  on: { click: _vm.addField },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("add"),
                                  ]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("Button.Add_Metadata_Field")
                                      ) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            disabled: !_vm.isValidForm,
                          },
                          on: { click: _vm.onPostSchema },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { depressed: "" },
                          on: { click: _vm.clickCancel },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }